import {css} from '@emotion/core';
import React from 'react';
import {useHistory} from 'react-router-dom';
import {Tab} from 'semantic-ui-react';
import {routes} from '../routes';
import {MobileaseTheme} from '../styles/branding';
import {MonthlyInvoiceListing} from './monthly-invoice-listing';
import {SupplementalInvoiceListing} from './supplemental-invoice-listing';

export enum InvoiceListingTabTypes {
  MONTHLY = 'MONTHLY',
  SUPPLEMENTAL = 'SUPPLEMENTAL',
}

export const InvoiceTypeRoutesMap: {[T in InvoiceListingTabTypes]: string} = {
  [InvoiceListingTabTypes.MONTHLY]: routes.invoices.monthly,
  [InvoiceListingTabTypes.SUPPLEMENTAL]: routes.invoices.supplemental,
};

const panes = [
  {
    menuItem: 'Monthly',
    render: () => (
      <Tab.Pane as="string">
        <MonthlyInvoiceListing />
      </Tab.Pane>
    ),
    tabType: InvoiceListingTabTypes.MONTHLY,
  },
  {
    menuItem: 'Supplemental',
    render: () => (
      <Tab.Pane as="string">
        <SupplementalInvoiceListing />
      </Tab.Pane>
    ),
    tabType: InvoiceListingTabTypes.SUPPLEMENTAL,
  },
];

export const InvoiceListing: React.FC<{
  activeTab: InvoiceListingTabTypes;
}> = ({activeTab}) => {
  const history = useHistory();
  return (
    <div css={styles}>
      <Tab
        menu={{secondary: true, pointing: true}}
        panes={panes}
        activeIndex={panes.findIndex((x) => x.tabType === activeTab)}
        onTabChange={(event, data) => {
          history.push(
            InvoiceTypeRoutesMap[panes[data.activeIndex as number].tabType]
          );
        }}
      />
    </div>
  );
};

export const styles = css`
  .ui.secondary.menu .item,
  .ui.secondary.menu .item.active {
    font-size: 1.25rem;
  }

  .ui.secondary.menu .item.active {
    font-weight: bold;
  }

  .ui.secondary.pointing.menu {
    padding: 0rem 2rem;
  }

  .ui.menu.secondary.pointing .active.item {
    border-color: ${MobileaseTheme.colors.blue500};
  }
`;
